import script from "./Presse.vue?vue&type=script&setup=true&lang=js"
export * from "./Presse.vue?vue&type=script&setup=true&lang=js"

import "./Presse.vue?vue&type=style&index=0&id=f367082e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f367082e"]])

export default __exports__